export default [
  {
    // [0]
    type: "v-select",
    margin: true,
    showLabel: true,
    label: "Grupo Entidad",
    labelName: "name",
    options: [],
    model: null,
    cols: 12,
  },
  {
    // [1]
    type: "b-form-select",
    margin: true,
    showLabel: true,
    label: "Régimen asignado",
    options: [
      { value: 0, text: "TODOS LOS CONDUCTORES" },
      { value: 1, text: "SOLO CON RÉGIMEN ASIGNADO" },
    ],
    model: 0,
    cols: 12,
  },
];
